import { css } from '@emotion/react';

export const link = css`
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;
